/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-03-31 13:59:29
 * @LastEditors: m
 * @LastEditTime: 2020-08-24 10:31:40
 */

// const httpURL = "http://es.10led.com:8069/api";
// const fileUrl = "http://es.10led.com:8069/download/";
// const Name = "测试CRM系统";
// const LOGO = require('../img/wylogo.png');


// const httpURL = "https://ws-api.ledv8.com/api";   
// const fileUrl = "https://ws-api.ledv8.com/download/";
// const Name = "纬思集团CRM系统";
// const LOGO = require('../img/wslogo.png');


// const httpURL = "https://ww.ledjf.com:60/api";
// const fileUrl = "https://ww.ledjf.com:60/download/";
// const Name = "科锐晶丰CRM系统";
// const LOGO = require('../img/sxlogo.png');


// const httpURL = "https://ww.ledjf.com:62/api";
// const fileUrl = "https://ww.ledjf.com:62/download/";
// const Name = "德诺集成CRM系统";
// const LOGO = require('../img/cqlogo.png');


// const httpURL = "https://ww.ledjf.com:64/api";
// const fileUrl = "https://ww.ledjf.com:64/download/";
// const Name = "睿鹤光电CRM系统";
// const LOGO = require('../img/cqlogo.png');

const httpURL = "https://ww.ledjf.com:66/api";
const fileUrl = "https://ww.ledjf.com:66/download/";
const Name = "衡亮科技CRM系统";
const LOGO = require('../img/hllogo.png');


export default {
    httpURL,
    fileUrl,
    Name,
    LOGO,
};
//说明：启动命令npm  run  dev   打包命令：npm run build